<template>
  <div id="app" ref="navbar">
    <HeadView></HeadView>
    <router-view />
    <el-backtop target="#app" :bottom="100"></el-backtop>
    <!--back_top 返回顶部_end-->

    <!--    遮盖层  -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="100%"
      :show-close="false"
      custom-class="dialogClass"
      :before-close="handleClose">
      <div class="trens">
        <img src="static/assets/img/logo.jpg"  :height="imgh+'px'" :width="imgw+'px'"   class="trens-img"  alt="">
      </div>
    </el-dialog>

  </div>
</template>

<script>
import HeadView from "@/components/Head";
var _tha
export default {
  components: {
    HeadView
  },
  data(){
    return{
      imgh:'85', // 64px  85px      60
      imgw:'168', //126px  168px    221
      dialogVisible: false,
      prevScrollPos: 100,
      el: null,
      container: null,
      visible: false,
      target:'#app'
      // VisibleBG: {
      //   backgroundImage:
      //     "url(" + require("../static/assets/img/logo.jpg") + ")",
      //   backgroundSize: "cover",
      //   backgroundRepeat: "no-repeat",
      //   backgroundPosition: "center center",
      // },
    }
  },
  mounted() {
    this.init();
    this.container.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy() {
    this.$win.removeEventListener('scroll', this.onScroll);
  },
  created() {
    this.dialogVisible = true
    let _th = this;
    var timer  = setInterval(()=>{
        this.imgw++;
        this.imgh++;
        if(this.imgh>70)
          clearInterval(timer)
    },30)
    setTimeout(()=>{
      this.dialogVisible = false
    },3000)

    this.$nextTick(() => {
      // 禁用右键
      _th.$win.document.oncontextmenu = new Function('event.returnValue=false')
      // 禁用选择
      _th.$win.document.onselectstart = new Function('event.returnValue=false')
      //禁止f12
      _th.$win.document.onkeydown = new Function('event.returnValue=false')

      // 选择所有图片元素
      var images = document.querySelectorAll('img.nosave');

// 给每个图片元素添加事件监听器
      images.forEach(function(img) {
        img.addEventListener('contextmenu', function(e) { // 右键菜单
          e.preventDefault();
          return false;
        });

        img.addEventListener('mousedown', function(e) { // 鼠标按下
          if (e.button === 2) { // 右键点击
            e.preventDefault();
            return false;
          }
        });

        // 对于触屏设备，可以尝试阻止长按动作
        img.addEventListener('touchstart', function(e) {
          e.preventDefault(); // 阻止默认的触摸行为
        });
      });


    });
    //
    // // 上面的禁止f12那段代码没有生效，但是加了下面这段就能生效。
    // _th.$win.document.onkeydown = function (e) {
    //   if (e && e.keyCode === 123) {
    //     e.returnValue = false
    //     // e.keyCode = 0   //去掉也可以的，倘若要写，则需要setter 以及 getter配合使用，不配合，会报错
    //     return false
    //   }
    // }
  },
  methods:{
    init() {
      this.container = document;
      this.el = document.documentElement;
      if (this.target) {
        this.el = document.querySelector(this.target);
        if (!this.el) {
          throw new Error(`target is not existed: ${this.target}`);
        }
        this.container = this.el;
      }
    },
    onScroll() {
      const scrollTop = this.el.scrollTop;
      this.$store.state.scrollHeight = scrollTop >= this.prevScrollPos;
    },
    handleClose(done){
      console.log(done+'---------------')
    }
  }
};
</script>

<style type="text/scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow-x: hidden; /* 禁止水平滚动 */
  overscroll-behavior-x: none; /* 禁止iOS上的过度滚动效果 */
  overflow: scroll;
  height: 100%;
}
/deep/ .el-dialog__body{
  padding: 0!important;
}
.dialogClass{
  margin-top: 0!important;
  height: 100vh;
  background: black!important;
}
.trens{
  height: 90vh;
  background: black!important;
  position: relative;
}
.trens-img{
  position: relative;
  top: 35vh;
}
h1,
h2 {
  font-weight: normal;
}
ul，dl {
  list-style-type: none;
  padding: 0;
}
li,
dd {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #c0c4cc;
  text-decoration: none;
}
.pre100 {
  height: 100%;
  width: 100%;
}
.el-main {
  min-height: 60vh;
}
.el-main,
h1 {
  margin: 0;
  padding: 0;
}
.el-lineheight {
  height: 60px;
  line-height: 60px;
  background-color: #cfcfcf;
}
.bg-purple-dark {
  background: #99a9bf;
}

/* common  */
/deep/ .el-footer {
  padding: 0 !important;
}
.main-div {
  min-height: 80vh;
  font-size: 1rem; overflow-x: hidden!important; /* 禁止水平滚动 */
  overscroll-behavior-x: none!important; /* 禁止iOS上的过度滚动效果 */
}

.servicetimewarp {
  padding: 5px 20px;
  background: #1a1a1a;
  border-radius: 10px;
  border: 1px #ccc solid;
  font-size: 12px;
  color: #bfbfbf;
}
.telcolor {
  font-weight: bold;
  color: white;
  line-height: 2.125rem;
  align-items: center;
  font-size: 1.75rem;
}
/************************************************************/

.borderTop {
  border-top: 1px solid #dddddd;
}
.borderB {
  border-bottom: 1px solid #dddddd;
}
.borderRadius4 {
  border-radius: 4px;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.h4 {
  margin: 0;
  padding: 0;
}
.textRight {
  text-align: right;
}
.textLeft {
  text-align: left;
}
.textCenter {
  text-align: center;
}
.margin0 {
  margin: 0;
}
.marginB20 {
  margin-bottom: 3%;
}
.marginB1 {
  margin-bottom: 1%;
}
.fontSize20 {
  font-size: 20px;
}
.padding0 {
  padding: 0;
}
.paddingB10 {
  padding-bottom: 10px;
}
.paddingT10 {
  padding-top: 10px;
}
.paddingT30 {
  padding-top: 30px;
}
.paddingT50 {
  padding-top: 50px;
}
.paddingL10 {
  padding-left: 10px;
}
.paddingL5 {
  padding-left: 5px;
}
.commLinearColor {
  background-color: #303133; /* 浏览器不支持时显示 */
  background-image: linear-gradient(to bottom, #1f9ed2, #5fb6d9);
  -o-background-image: linear-gradient(to bottom, #1f9ed2, #5fb6d9);
  webkit-background-image: linear-gradient(to bottom, #1f9ed2, #5fb6d9);
}
/************************************************************/


.homeMain {
  min-height: 300px;
}
html,
body {
  height: 100%;
  margin-left: 0;
  margin-right: 0px;
}
body {
  overflow: hidden;
}
/*************************¶ Backtop 回到顶部***********************************/

.customClass {
  background-color: #334454;
}
.customTClass {
  background-color: white;
}
.clr {
  zoom: 1;
}
.left_menu dl dd .dd_title {
  position: relative;
}
.el-drawer__body {
  background-color: #1a1a1a;
}
.el-drawer__body dl dd a {
  padding: 8px 0 8px 20px;
  display: block;
  font-size: 16px;
  line-height: 25px;
  color: #ffffff;
  border-bottom: 1px solid #1a2634;
  border-top: 1px solid #4b5a68;
  background-color: rgba(88, 120, 146, 0.2);
}
.el-drawer__body dl dd i {
  padding-right: 10px;
}
.customClass dd,
.customClass dt {
  width: 100%;
  margin: 0px;
}
.ddChild {
  margin-right: 10px;
}
#problemDrawer .el-drawer__body {
  background-color: #ffffff;
  margin-top: 25px;
}
/********* wap_Aside 侧边栏_抽屉 **********/


img {
  //pointer-events: none; /* 禁止图片上的指针事件，包括长按 */
  -webkit-user-select: none; /* 禁止 WebKit 浏览器（如 Safari、Chrome）选择文本或图片 */
  -moz-user-select: none; /* 禁止 Firefox 选择文本或图片 */
  -ms-user-select: none; /* 禁止 IE/Edge 选择文本或图片 */
  user-select: none; /* 禁止标准浏览器选择文本或图片 */

  /* 对于旧版 WebKit 浏览器，取消长按弹出菜单 */
  -webkit-touch-callout: none; /* 禁止触摸操作时出现的系统菜单 */
}

</style>



// WEBPACK FOOTER //
// src/App.vue